import lukas from '../img/lukas-carey-logo.png';
import eidsteddfod from '../img/parramatta-eidsteddfod.png'; 
import apcci from '../img/apcci.png';

export const projects = [
    {
        id: 1,
        imgId: "lukasId",
        photo: lukas,
        url: "https://www.lukascarey.com.au/",
        title: "Project Lukas",
        description: "Dr. Lukas Carey is a strong advocate for the importance of Convict Criminology and the lived experience to govern the direction of related policies and practices."
    },
    {
        id: 2,
        imgId: "eidsteddfodId",
        photo: eidsteddfod,
        url: "https://www.eisteddfodparramatta.org.au/",
        title: "Parramatta Eisteddfod",
        description: `Parramatta Eisteddfod is a not-for-profit organisation of volunteers whose aim is to provide a safe and encouraging performance arts event for the young people.`
    },
    {
        id: 3,
        imgId: "apcciId",
        photo: apcci,
        url: "https://apcci.vercel.app/",
        title: "Aus Phil Chamber of Commerce Inc.",
        description: `The APCCI supports Australia–Philippines trade, investment, and collaboration by providing a voice, network, and platform for cross-border business growth.`
    }
    
];